import { eksmoBP } from 'Lib/bp/bp';
import { speed } from 'Lib/speed/speed';
import { onScreen } from 'Lib/on-screen/on-screen';
import { eventSender } from 'Lib/event-sender/event-sender';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import { getW } from 'Lib/w/w';
import fastdom from 'fastdom';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';

const oTripleSlider = {
    sParent: '.triple-slider',
    cLoaded: 'triple-slider__slider_loaded',
    cLoadedOpacity: 'triple-slider__slider_loaded-opacity',
    cShowed: 'triple-slider__slider_showed',
    cItem: 'triple-slider__item',
    cItemHidden: 'triple-slider__item_hidden',
    cItemLeft: 'triple-slider__item_left',
    cItemLeftHalf: 'triple-slider__item_left-half',
    cItemActive: 'triple-slider__item_active',
    cItemRightHalf: 'triple-slider__item_right-half',
    cItemRight: 'triple-slider__item_right',
    sLinkNext: '.triple-slider__next',
    sLinkPrev: '.triple-slider__prev',
    sImg: '.triple-slider__img',
    sBgFullPic: '.triple-slider__full-pic-link',
    sArrows: '.triple-slider__arrows',
    slideWidth: 715,
    movedSidesTo: 0,
    setIntervalId: false,
    inited: false,
    countSlide: 0,
    youtubeAPI: false,
    tagLoadVideoYoutube: '',
    playerYoutube: '',
    journalRight: $('.wrapper-content__with-journal-right'),

    init(s, autoplayTimeout, mSW, mST) {
        if (!oTripleSlider.inited && getW() > eksmoBP.xsMax) {
            const $slider = $(s);
            const $p = $slider.closest(oTripleSlider.sParent);
            const $next = $p.find(oTripleSlider.sLinkNext);
            const $prev = $p.find(oTripleSlider.sLinkPrev);
            let playSpeed = 5000;

            if ($slider.find(`.${oTripleSlider.cItem}`).length) {
                const $body = $('body');

                if (typeof mSW === 'number') {
                    oTripleSlider.slideWidth = mSW;
                }

                if (typeof mST === 'number') {
                    oTripleSlider.movedSidesTo = mST;
                }

                if (typeof autoplayTimeout === 'number') {
                    playSpeed = autoplayTimeout;
                }

                oTripleSlider.setSlider($slider);
                $slider.addClass(oTripleSlider.cLoaded);

                setTimeout(() => {
                    $slider.addClass(oTripleSlider.cLoadedOpacity);
                }, speed * 3);

                setTimeout(() => {
                    $slider.addClass(oTripleSlider.cShowed);
                }, speed * 7);

                $body.on('eksmoResizeWidth', () => {
                    oTripleSlider.setPosition($slider);
                });

                $slider.on('click', `.${oTripleSlider.cItemRightHalf}`, (e) => {
                    e.preventDefault();
                    oTripleSlider.next($slider);
                });

                $slider.on('click', `.${oTripleSlider.cItemLeftHalf}`, (e) => {
                    e.preventDefault();
                    oTripleSlider.prev($slider);
                });

                if ($next.length) {
                    $next.on('click', () => {
                        oTripleSlider.next($slider);
                        oTripleSlider.autoPlay($slider);
                    });
                }

                if ($prev.length) {
                    $prev.on('click', () => {
                        oTripleSlider.prev($slider);
                        oTripleSlider.autoPlay($slider);
                    });
                }

                oTripleSlider.autoPlay($slider, playSpeed);

                $p.on('mouseenter', () => {
                    oTripleSlider.autoPlay($slider);
                });

                $p.on('mouseleave', () => {
                    oTripleSlider.autoPlay($slider, playSpeed);
                });

                $body.on('click', '.triple-slider__item_video .triple-slider__img', (e) => {
                    oTripleSlider.loadVideo(e.target);
                });
            }

            oTripleSlider.inited = true;
        }
    },

    autoPlay($slider, speedValue) {
        const thisSpeed = parseInt(speedValue);

        if (thisSpeed) {
            oTripleSlider.setIntervalId = setInterval(() => {
                oTripleSlider.next($slider);
            }, thisSpeed);
        } else if (oTripleSlider.setIntervalId) {
            clearInterval(oTripleSlider.setIntervalId);
        }
    },

    next($slider) {
        let n = parseInt($slider.attr('data-n'));
        const $items = $slider.find(`.${oTripleSlider.cItem}`);

        if ($items.length) {
            $slider.append($slider.find(`.${oTripleSlider.cItem}`).first().remove());
            oTripleSlider.setPosition($slider);

            if (n >= oTripleSlider.countSlide) {
                n = 1;
            } else {
                n++;
            }

            $slider.attr('data-n', n);
        }

        oTripleSlider.closeVideo();
    },

    prev($slider) {
        let n = parseInt($slider.attr('data-n'));
        const $items = $slider.find(`.${oTripleSlider.cItem}`);

        if ($items.length) {
            $slider.prepend($slider.find(`.${oTripleSlider.cItem}`).last().remove());
            oTripleSlider.setPosition($slider);

            if (n <= 1) {
                n = $items.length;
            } else {
                n--;
            }

            $slider.attr('data-n', n);
        }

        oTripleSlider.closeVideo();
    },

    slideTo($slider, num) {
        const newN = parseInt(num);
        const $items = $slider.find(`.${oTripleSlider.cItem}`);

        if (newN && newN > 0 && newN <= $items.length) {
            const n = parseInt($slider.attr('data-n'));

            if (newN !== n) {
                const numDiff = newN - n;
                const numDiffAbs = Math.abs(numDiff);

                if (numDiff !== 0) {
                    $items.addClass(oTripleSlider.cItemHidden);

                    for (let i = 1; i <= numDiffAbs; i++) {
                        if (numDiff > 0) {
                            $slider.append($slider.find(`.${oTripleSlider.cItem}`).first().remove());
                        } else if (numDiff < 0) {
                            $slider.prepend($slider.find(`.${oTripleSlider.cItem}`).last().remove());
                        }
                    }

                    oTripleSlider.setPosition($slider);
                    $slider.attr('data-n', newN);

                    setTimeout(() => {
                        $items.removeClass(oTripleSlider.cItemHidden);
                    }, speed * 3);
                }
            }
        }
    },

    setClasses($slider) {
        const $items = $slider.find(`.${oTripleSlider.cItem}`);

        $items
            .removeClass(oTripleSlider.cItemLeft)
            .removeClass(oTripleSlider.cItemLeftHalf)
            .removeClass(oTripleSlider.cItemActive)
            .removeClass(oTripleSlider.cItemRightHalf)
            .removeClass(oTripleSlider.cItemRight)
            .each(function (i) {
                if ($items.length === 1) {
                    $(this).addClass(oTripleSlider.cItemActive);
                } else if ($items.length === 2) {
                    if (i === 0) {
                        $(this).addClass(oTripleSlider.cItemLeftHalf);
                    } else if (i === 1) {
                        $(this).addClass(oTripleSlider.cItemActive);
                    }
                } else if ($items.length === 3) {
                    if (i === 0) {
                        $(this).addClass(oTripleSlider.cItemLeftHalf);
                    } else if (i === 1) {
                        $(this).addClass(oTripleSlider.cItemActive);
                    } else if (i === 2) {
                        $(this).addClass(oTripleSlider.cItemRightHalf);
                    }
                } else if ($items.length >= 4) {
                    if (i === 0) {
                        $(this).addClass(oTripleSlider.cItemLeft);
                    } else if (i === 1) {
                        $(this).addClass(oTripleSlider.cItemLeftHalf);
                    } else if (i === 2) {
                        $(this).addClass(oTripleSlider.cItemActive);
                    } else if (i === 3) {
                        $(this).addClass(oTripleSlider.cItemRightHalf);
                    } else if (i === 4) {
                        $(this).addClass(oTripleSlider.cItemRight);
                    }
                }
            });
    },

    setPosition($slider) {
        fastdom.measure(() => {
            const newW = oTripleSlider.journalRight.length ? oTripleSlider.journalRight.outerWidth() : getW();
            const slideWidth = $slider.find(`.${oTripleSlider.cItem}`).first().outerWidth(true);

            if (newW <= eksmoBP.mdMax) {
                oTripleSlider.movedSidesTo = slideWidth;
            }

            let translateItemLeftHalf = -parseInt(newW + (slideWidth / 2) + oTripleSlider.movedSidesTo);

            if (oTripleSlider.journalRight.length) {
                translateItemLeftHalf -= 200;
            }

            fastdom.mutate(() => {
                oTripleSlider.setClasses($slider);
                oTripleSlider.loadImages($slider);

                const $activeSlide = $slider.find(`.${oTripleSlider.cItemActive}`);

                $slider.find(`.${oTripleSlider.cItemLeft}`).css({ 'transform': `translateX(${-parseInt(newW + (slideWidth * 3))}px)` });
                $slider.find(`.${oTripleSlider.cItemLeftHalf}`).css({ 'transform': `translateX(${translateItemLeftHalf}px)` });
                $activeSlide.css({ 'transform': `translateX(${-parseInt(oTripleSlider.slideWidth + ((newW - oTripleSlider.slideWidth) / 2))}px)` });
                $slider.find(`.${oTripleSlider.cItemRightHalf}`).css({ 'transform': `translateX(${oTripleSlider.journalRight.length ? '50' : -parseInt((slideWidth / 2) - oTripleSlider.movedSidesTo)}px)` });
                $slider.find(`.${oTripleSlider.cItemRight}`).css({ 'transform': `translateX(${parseInt(slideWidth * 3)}px)` });
            });
        });
    },

    setSlider($slider) {
        const $p = $slider.closest(oTripleSlider.sParent);
        const $items = $slider.find(`.${oTripleSlider.cItem}`);
        const $arrows = $p.find(oTripleSlider.sArrows);

        if ($items.length === 1) {
            $arrows.hide();
        }

        $slider.prepend($slider.find(`.${oTripleSlider.cItem}`).last().remove());
        $slider.prepend($slider.find(`.${oTripleSlider.cItem}`).last().remove());
        oTripleSlider.setPosition($slider);
        $slider.attr('data-n', 1);
        oTripleSlider.countSlide = $items.length;
    },

    loadImages($slider) {
        const $Img = $slider.find($slider.find(`.${oTripleSlider.cItemLeftHalf}`).find(oTripleSlider.sImg))
            .add($slider.find(`.${oTripleSlider.cItemActive}`).find(oTripleSlider.sImg))
            .add($slider.find(`.${oTripleSlider.cItemRightHalf}`).find(oTripleSlider.sImg));
        const $bgLoader = $slider.find($slider.find(`.${oTripleSlider.cItemLeftHalf}`).find(oTripleSlider.sBgFullPic))
            .add($slider.find(`.${oTripleSlider.cItemActive}`).find(oTripleSlider.sBgFullPic))
            .add($slider.find(`.${oTripleSlider.cItemRightHalf}`).find(oTripleSlider.sBgFullPic));

        loadSrcOrBg($Img);
        loadSrcOrBg($bgLoader);
    },

    loadVideo(elActive) {
        if (!oTripleSlider.youtubeAPI) {
            oTripleSlider.tagLoadVideoYoutube = document.createElement('script');
            oTripleSlider.tagLoadVideoYoutube.src = 'https://www.youtube.com/player_api';

            const firstScriptTag = document.getElementsByTagName('script')[0];

            firstScriptTag.parentNode.insertBefore(oTripleSlider.tagLoadVideoYoutube, firstScriptTag);

            oTripleSlider.tagLoadVideoYoutube.onload = function () {
                oTripleSlider.loadYoutubeAPI(oTripleSlider.playerYoutube, elActive);
                oTripleSlider.youtubeAPI = true;
            };
        } else {
            oTripleSlider.loadYoutubeAPI(oTripleSlider.playerYoutube, elActive);
        }
    },

    loadYoutubeAPI(player, elActive) {
        window.YT.ready(() => {
            const elParent = elActive.closest('.triple-slider__item');

            elParent.classList.add('triple-slider__item_video-active');

            // eslint-disable-next-line no-param-reassign
            player = new window.YT.Player(elActive, {
                height: '360',
                width: '540',
                playerVars: {
                    'rel': '0',
                    'showinfo': '0',
                    'autoplay': '1',
                    'iv_load_policy': '3',
                    'ytp-pause-overlay': '0',
                    'modestbranding': '0',
                },
                videoId: elParent.getAttribute('data-video'),
                events: {
                    onReady: onPlayerReady,
                },
            });

            oTripleSlider.autoPlay('', '');
        });

        function onPlayerReady(event) {
            event.target.playVideo();
        }
    },

    closeVideo() {
        document.querySelectorAll('.triple-slider__item_video-active .triple-slider__pic-cell').forEach((item) => {
            item.innerHTML = '';
            item.classList.remove('triple-slider__item_video-active');

            item.insertAdjacentHTML('afterbegin', `
                <div class="triple-slider__img img img_play">
                  <img src="${item.getAttribute('data-src')}">
                </div>
            `);
        });
    },
};

oTripleSlider.init('.triple-slider__slider');

$('body').on('eksmoResizeWidth', () => {
    oTripleSlider.init('.triple-slider__slider');
});